import { render, staticRenderFns } from "./instagram_comment.vue?vue&type=template&id=4c492467&scoped=true"
import script from "./instagram_comment.vue?vue&type=script&lang=js"
export * from "./instagram_comment.vue?vue&type=script&lang=js"
import style0 from "./instagram_comment.vue?vue&type=style&index=0&id=4c492467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c492467",
  null
  
)

export default component.exports